export enum EDateFilterTypes {
  THIS_MONTH = 'thisMonth',
  PAST_MONTH = 'pastMonth',
  THIS_QUARTER = 'thisQuarter',
  PAST_QUARTER = 'pastQuarter',
  THIS_YEAR = 'thisYear',
  PAST_YEAR = 'pastYear',
  CUSTOM = 'custom',
}

export type TDateFilterInterval = { from: Date | null; to: Date | null };
